(function ($) {
    'use strict';

    $(document).ready(function () {
        console.log('Skrypt single-product.js zainicjowany.');

        var swiperThumbs = null;
        var swiperMain = null;
        var swiperRelated = null;

        function initProductSwipers() {
            if (typeof Swiper === 'undefined') {
                console.warn(
                    'Biblioteka Swiper nie jest jeszcze dostępna. Oczekiwanie na załadowanie...',
                );
                return false;
            }

            /* ==========================================================================
               1. GALERIA PRODUKTU (GŁÓWNY + THUMBS)
               ========================================================================== */
            if ($('.thumbs-product-slider').length > 0 && !swiperThumbs) {
                swiperThumbs = new Swiper('.thumbs-product-slider', {
                    spaceBetween: 15,
                    slidesPerView: 3,
                    watchSlidesProgress: true,
                    freeMode: true,
                    centerInsufficientSlides: true,
                });

                swiperMain = new Swiper('.main-product-slider', {
                    spaceBetween: 10,
                    effect: 'fade',
                    fadeEffect: { crossFade: true },
                    thumbs: { swiper: swiperThumbs },
                });
            }

            /* ==========================================================================
               2. SEKCJA "ZOBACZ RÓWNIEŻ" (RELATED PRODUCTS)
               ========================================================================== */
            if ($('.rs-related-swiper').length > 0 && !swiperRelated) {
                swiperRelated = new Swiper('.rs-related-swiper', {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true, // Zmień z false na true, aby włączyć nieskończoną pętlę
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true, // Opcjonalnie: wstrzymuje przewijanie po najechaniu myszką
                    },
                    pagination: {
                        el: '.rs-related-swiper .swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.rs-related-swiper .swiper-button-next',
                        prevEl: '.rs-related-swiper .swiper-button-prev',
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 0,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 0,
                        },
                    },
                });
            }

            return true;
        }

        // Pierwsza próba inicjalizacji
        if (!initProductSwipers()) {
            $(window).on('load', function () {
                initProductSwipers();
            });
        }

        /* ==========================================================================
           3. INTEGRACJA Z WARIANTAMI WOOCOMMERCE
           ========================================================================== */
        $(document).on(
            'found_variation reset_data',
            'form.variations_form',
            function () {
                if (swiperMain && swiperThumbs) {
                    setTimeout(function () {
                        swiperMain.update();
                        swiperThumbs.update();
                        swiperMain.slideTo(0);
                    }, 100);
                }
            },
        );
    });
})(jQuery);

// obsługa filmu YT
document.addEventListener('DOMContentLoaded', function () {
    const videoFacades = document.querySelectorAll('.yt-facade');

    videoFacades.forEach(function (facade) {
        facade.addEventListener('click', function () {
            const videoId = this.getAttribute('data-video-id');

            if (!videoId) return;

            const iframe = document.createElement('iframe');

            iframe.setAttribute(
                'src',
                'https://www.youtube.com/embed/' +
                    videoId +
                    '?autoplay=1&rel=0',
            );
            iframe.setAttribute('title', 'YouTube video player');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute(
                'allow',
                'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
            );
            iframe.setAttribute('allowfullscreen', 'true');

            this.innerHTML = '';
            this.appendChild(iframe);
            this.classList.add('is-loaded');
        });
    });

    const faqAccordions = document.querySelectorAll('[data-faq-accordion]');

    faqAccordions.forEach(function (accordion) {
        const items = accordion.querySelectorAll('.faq-item');

        const closeItem = function (item) {
            const trigger = item.querySelector('.faq-question');
            const panel = item.querySelector('.faq-answer');

            if (!trigger || !panel) {
                return;
            }

            panel.style.height = panel.scrollHeight + 'px';
            panel.offsetHeight;
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            panel.style.height = '0px';
            panel.style.opacity = '0';

            window.setTimeout(function () {
                if (!item.classList.contains('is-open')) {
                    panel.hidden = true;
                    panel.style.height = '';
                }
            }, 300);
        };

        const openItem = function (item) {
            const trigger = item.querySelector('.faq-question');
            const panel = item.querySelector('.faq-answer');

            if (!trigger || !panel) {
                return;
            }

            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
            panel.style.height = '0px';
            panel.style.opacity = '0';
            panel.offsetHeight;
            panel.style.height = panel.scrollHeight + 'px';
            panel.style.opacity = '1';

            const onOpened = function (event) {
                if (event.propertyName !== 'height') {
                    return;
                }

                if (item.classList.contains('is-open')) {
                    panel.style.height = 'auto';
                }

                panel.removeEventListener('transitionend', onOpened);
            };

            panel.addEventListener('transitionend', onOpened);
        };

        items.forEach(function (item) {
            const trigger = item.querySelector('.faq-question');
            const panel = item.querySelector('.faq-answer');

            if (!trigger || !panel) {
                return;
            }

            panel.hidden = true;
            panel.style.height = '0px';
            panel.style.opacity = '0';

            trigger.addEventListener('click', function () {
                const isOpen = item.classList.contains('is-open');

                items.forEach(function (otherItem) {
                    if (otherItem !== item) {
                        closeItem(otherItem);
                    }
                });

                if (isOpen) {
                    closeItem(item);
                } else {
                    openItem(item);
                }
            });
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const ctaBuyButton = document.querySelector('.cta-buy-button');

    if (!ctaBuyButton) return;

    ctaBuyButton.addEventListener('click', function (e) {
        e.preventDefault();

        const action = this.getAttribute('data-action');
        const nativeWooForm = document.querySelector('form.cart');

        if (!nativeWooForm) {
            console.warn(
                'Nie znaleziono domyślnego formularza koszyka WooCommerce.',
            );
            return;
        }

        if (action === 'variable') {
            nativeWooForm.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });

            const firstSelect = nativeWooForm.querySelector('select');
            if (firstSelect) {
                setTimeout(() => firstSelect.focus(), 600);
            }
        } else if (action === 'simple') {
            const nativeSubmitButton = nativeWooForm.querySelector(
                '.single_add_to_cart_button',
            );

            if (nativeSubmitButton) {
                nativeSubmitButton.click();
            } else {
                nativeWooForm.submit();
            }
        }
    });
});
